export const CSV_DOWNLOAD_LABEL = 'Download Reports'
export const DOWNLOAD_LINK_TEXT = 'Export'
export const UPDATED_DOWNLOAD_LINK_TEXT = 'Your Report'
